/* ============================================================
   NIGHTLEGS — PRESELL "THE SPOT" (/pages/the-spot)
   Loaded (defer) by sections/presell-offer.liquid only.
   - CTA links: carry utm_* / fbclid through to the PDP, add from=spot, and
     (offer button only) pairs=<qty> so the PDP preselects the tier she picked.
   - Offer button adds her pick to the cart drawer (PDP fallback); sticky + P.S. scroll to the picker.
   - Night bar (reading progress) + scroll-depth events.
   - 10-second test buttons, drawer checklist, sticky bar.
   - Offer cards: the PDP's exact price math (mirrors product-gallery.js).
   Events go to Shopify.analytics.publish (custom pixels can subscribe).
   The theme Meta pixel stays OFF (app-owned CAPI) — never call fbq here.
   ============================================================ */
(function () {
  'use strict';
  var d = document, w = window;

  function publish(name, data) {
    try {
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') {
        w.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  }

  /* ---------- CTA links ---------- */
  var PASS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];
  var incoming = {};
  try {
    var sp = new URLSearchParams(w.location.search);
    PASS.forEach(function (k) { var v = sp.get(k); if (v) incoming[k] = v; });
  } catch (e) {}

  var offer = d.getElementById('ps-offer');
  var baseUrl = (offer && offer.getAttribute('data-product-url')) ||
                (w.nightlegs && w.nightlegs.productUrl) || '/';

  function buildUrl(base, pairs) {
    var u;
    try { u = new URL(base || baseUrl, w.location.origin); } catch (e) { return base || baseUrl; }
    if (pairs) u.searchParams.set('pairs', String(pairs)); else u.searchParams.delete('pairs');
    u.searchParams.set('from', 'spot');
    Object.keys(incoming).forEach(function (k) { u.searchParams.set(k, incoming[k]); });
    return u.pathname + u.search;
  }

  Array.prototype.forEach.call(d.querySelectorAll('a[data-ps-cta]'), function (a) {
    // Non-offer CTAs pass no "pairs": the PDP keeps its own default tier.
    if (!a.hasAttribute('data-ps-offer-btn')) a.setAttribute('href', buildUrl(a.getAttribute('href'), null));
    a.addEventListener('click', function () { publish('presell_cta', { position: a.getAttribute('data-ps-cta') || '' }); });
  });

  /* ---------- 10-second test ---------- */
  Array.prototype.forEach.call(d.querySelectorAll('[data-ps-test]'), function (card) {
    var reply = card.querySelector('[data-ps-test-reply]');
    var btns = card.querySelectorAll('[data-reply]');
    Array.prototype.forEach.call(btns, function (btn) {
      btn.addEventListener('click', function () {
        Array.prototype.forEach.call(btns, function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        if (reply) { reply.textContent = btn.getAttribute('data-reply') || ''; reply.hidden = !reply.textContent; }
        publish('presell_test', { answer: btn.getAttribute('data-answer') || '' });
      });
    });
  });

  /* ---------- Drawer checklist ---------- */
  Array.prototype.forEach.call(d.querySelectorAll('[data-ps-drawer]'), function (box) {
    var chips = Array.prototype.slice.call(box.querySelectorAll('[data-chip]'));
    var result = box.querySelector('[data-ps-drawer-result]');
    var lines = box.querySelector('[data-ps-drawer-lines]');
    var zero = box.getAttribute('data-zero') || '';
    var tpl = box.getAttribute('data-count') || zero;
    function update() {
      var on = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; });
      if (result) result.textContent = on.length ? tpl.replace('{n}', String(on.length)) : zero;
      if (lines) {
        lines.innerHTML = '';
        on.forEach(function (c) {
          var t = c.getAttribute('data-line');
          if (!t) return;
          var p = d.createElement('p');
          p.className = 'ps-drawer__line';
          p.textContent = t;
          lines.appendChild(p);
        });
      }
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        update();
      });
    });
    update();
  });

  /* ---------- Offer cards: identical math to the PDP ---------- */
  var bundles = d.getElementById('ps-bundles');
  var offerBtn = d.querySelector('[data-ps-offer-btn]');
  var selectedQty = null;
  if (bundles) {
    var productData = null;
    try { var j = d.getElementById('ps-product-json'); if (j) productData = JSON.parse(j.textContent); } catch (e) {}
    var cards = Array.prototype.slice.call(bundles.querySelectorAll('.bundle-card'));
    // Product JSON prices arrive converted by Shopify Markets; discount amounts are
    // authored in shop (USD) cents, so convert them at the live rate (same as the PDP).
    var cur = (w.Shopify && w.Shopify.currency) || {};
    var fx = parseFloat(cur.rate) || 1;
    var sym = { GBP: '£', EUR: '€' }[cur.active] || '$';
    var money = function (c) { return sym + (Math.round(c) / 100).toFixed(2); };
    var variant = null;
    if (productData && productData.variants && productData.variants.length) {
      variant = productData.variants.filter(function (x) { return x.available; })[0] || productData.variants[0];
    }
    var unit = variant ? variant.price : 0;
    var unitCompare = (variant && variant.compare_at_price && variant.compare_at_price > unit) ? variant.compare_at_price : unit;
    var noun = (bundles.getAttribute('data-noun') || 'pair').toLowerCase();

    var totalFor = function (card) {
      var q = parseInt(card.getAttribute('data-qty'), 10) || 1;
      var disc = parseInt(card.getAttribute('data-discount-amount'), 10) || 0;
      return Math.max(0, Math.round(unit * q - disc * fx));
    };

    if (unit > 0) {
      cards.forEach(function (card) {
        var q = parseInt(card.getAttribute('data-qty'), 10) || 1;
        var tot = totalFor(card), comp = unitCompare * q, per = Math.round(tot / q);
        var t = card.querySelector('[data-role="total"]');
        var c = card.querySelector('[data-role="compare"]');
        var s = card.querySelector('[data-role="save"]');
        if (t) t.textContent = money(tot);
        if (c) c.textContent = comp > tot ? money(comp) : '';
        if (s) {
          if (comp > tot) { s.textContent = 'SAVE ' + money(comp - tot) + ' · ' + money(per) + ' per ' + noun; s.hidden = false; }
          else { s.textContent = ''; s.hidden = true; }
        }
      });
    }

    var select = function (card) {
      cards.forEach(function (c) {
        c.classList.remove('is-selected');
        var i = c.querySelector('input'); if (i) i.checked = false;
      });
      card.classList.add('is-selected');
      var inp = card.querySelector('input'); if (inp) inp.checked = true;
      selectedQty = parseInt(card.getAttribute('data-qty'), 10) || 1;
      if (offerBtn) offerBtn.setAttribute('href', buildUrl(baseUrl, selectedQty));
    };
    cards.forEach(function (card) {
      card.addEventListener('click', function () { select(card); publish('presell_tier', { pairs: parseInt(card.getAttribute('data-qty'), 10) || 1 }); });
    });
    var init = bundles.querySelector('.bundle-card.is-selected') || cards[0];
    if (init) select(init);
  } else if (offerBtn) {
    offerBtn.setAttribute('href', buildUrl(baseUrl, null));
  }

  /* ---------- Offer button: add her pick straight to the cart ---------- */
  // Same path as the PDP's Add to Cart (cart-drawer.js -> NightLegsCart.addItem): the cart
  // drawer opens, and the bundle discount + eBook gift apply there exactly as on the PDP.
  // If the drawer script is missing, the button keeps its href and opens the PDP with her pick.
  // Every tap adds her pick, exactly like the PDP's Add to Cart. A short lock stops an
  // accidental double-tap from adding twice; the header cart icon (below) handles the rest.
  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  if (offerBtn) {
    offerBtn.addEventListener('click', function (e) {
      var cart = w.NightLegsCart;
      var vid = variant ? variant.id : null;
      if (!cart || typeof cart.addItem !== 'function' || !vid) return;
      e.preventDefault();
      if (offerBtn.getAttribute('aria-busy') === 'true') return;
      offerBtn.setAttribute('aria-busy', 'true');
      setTimeout(function () { offerBtn.removeAttribute('aria-busy'); }, 2500);
      cart.addItem(vid, selectedQty || 1, offerBtn);
      publish('presell_atc', { pairs: selectedQty || 1 });
    });
  }

  // The header cart icon is hidden on this page until her cart has something in it,
  // so there is always a way back to checkout after she closes the drawer.
  var cartBtn = d.querySelector('.site-header__cart-btn');
  var showCartBtn = function (n) { if (cartBtn && n > 0) cartBtn.style.setProperty('display', 'flex', 'important'); };
  d.addEventListener('cart:updated', function (e) { showCartBtn(e.detail && e.detail.item_count); });
  if (cartBtn && w.fetch) {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { showCartBtn(c.item_count); })
      .catch(function () {});
  }

  // Sticky bar + P.S. link scroll to the pair picker instead of leaving the page.
  var picker = bundles || offer;
  if (picker) {
    Array.prototype.forEach.call(d.querySelectorAll('a[data-ps-cta="sticky"], a[data-ps-cta="ps"]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var calm = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var y = picker.getBoundingClientRect().top + (w.pageYOffset || 0) - 120;
        w.scrollTo({ top: Math.max(0, y), behavior: calm ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- Night bar, scroll depth, sticky bar ---------- */
  var fill = d.getElementById('ps-nightbar-fill');
  var sticky = d.getElementById('ps-sticky');
  var reveal = d.querySelector('[data-ps-reveal]');
  var marks = [25, 50, 75, 100], sent = {};
  var ticking = false;

  function frame() {
    ticking = false;
    var doc = d.documentElement;
    var max = doc.scrollHeight - w.innerHeight;
    var y = w.pageYOffset || doc.scrollTop || 0;
    var p = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
    if (fill) fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    var pct = Math.round(p * 100);
    marks.forEach(function (m) { if (pct >= m && !sent[m]) { sent[m] = true; publish('presell_scroll', { depth: m }); } });

    if (sticky) {
      var vh = w.innerHeight || doc.clientHeight;
      var past = reveal ? reveal.getBoundingClientRect().top < vh * 0.25 : p > 0.5;
      var offerIn = offer ? offer.getBoundingClientRect().top < vh * 0.9 : false;
      var show = past && !offerIn;
      if (show !== sticky.classList.contains('is-visible')) {
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; w.requestAnimationFrame(frame); } }
  w.addEventListener('scroll', onScroll, { passive: true });
  w.addEventListener('resize', onScroll);
  frame();
  publish('presell_view', {});
})();
